import React, { Component } from "react";
import { Row, Col, Container } from "reactstrap";
import { inyectionTrinidad } from "../../../redux/actions/SpiderActions";
import { connect } from "react-redux";
import Check from "../../../shared/assets/check.svg";

class Success extends Component {
  constructor(props) {
    super(props);
    localStorage.clear();
  }

  render() {
    return (
      <Container>
        <Row>
          <Col md={8} className="offset-md-2 ">
            <div className="card-shadow p-4 text-center">
              <div>
                <img
                  src={Check}
                  style={{ height: "9rem", marginTop: "16px" }}
                  alt=''
                />
              </div>

              <div
                className="mt-4"
                style={{
                  fontSize: "1.5rem",
                  color: "#000000",
                  fontWeight: "bold",
                }}
              >
                Solicitud enviada
              </div>

              <div
                className="mt-2"
                style={{
                  fontSize: "1rem",
                  color: "#000000",
                  fontWeight: "400",
                }}
              >
                Un ejecutivo se pondrá en contacto contigo a la brevedad.
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  trinidad: state.spider.trinidad,
});

const mapDispatchToProps = {
  inyectionTrinidad,
};
export default connect(mapStateToProps, mapDispatchToProps)(Success);
